<template>
  <div>
    <view-intro heading="Your folders" />
    <div class="d-flex mb-6">
      <v-btn color="primary" class="ml-auto" @click="uploadDialog = true">
        Upload Files
      </v-btn>
      <v-btn color="primary" class="ml-4" @click="dialog = !dialog">
        Create Folder
      </v-btn>
    </div>
    <div v-if="!loading && folders">
      <v-row v-if="folders.length > 0">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(folder, index) in folders"
          :key="index"
        >
          <v-card class="mx-auto">
            <v-img
              class="primary darken-1 white--text align-center"
              height="200px"
            >
              <div class="d-flex align-center justify-center">
                <v-icon size="120" color="white">mdi-folder</v-icon>
              </div>
            </v-img>
            <v-card-subtitle class="pb-0">
              <strong>{{ folder.name }}</strong>
            </v-card-subtitle>

            <v-card-text class="text--primary">
              <div>{{ folder.description }}</div>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text @click="openFolder(folder.id)">
                Open
              </v-btn>

              <v-btn
                color="red"
                text
                @click="initiateDelete(folder.id, folder.name)"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-card v-else height="500">
        <img
          src="../assets/Laptop-01.svg"
          alt="Empty"
          style="height: 80%; width: auto; margin: auto; display: block;"
          class="empty-img"
        />
        <v-card-title
          class="text--secondary text-h4 mx-auto mt-n16 empty-text"
          style="text-align: center; display: block;"
          ><strong>You have not created have any folders</strong></v-card-title
        >
      </v-card>
    </div>
    <div class="mt-16" v-else>
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      <v-card-title class="text--secondary text-h6 mx-auto mt-n16 empty-text"
        ><strong>Getting your folders</strong></v-card-title
      >
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-form ref="folderCreateForm" @submit.prevent="createFolder">
          <v-card-title>
            <span class="text-h5 my-3"><strong>Create New Folder</strong></span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    filled
                    label="Folder Name"
                    v-model.trim="folderName"
                    :counter="10"
                    :rules="[
                      v => !!v || 'Folder Name is required',
                      v =>
                        v.length <= 10 ||
                        'Folder name must be less than 10 characters'
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model.trim="folderDescription"
                    filled
                    :counter="12"
                    label="Folder Description"
                    :rules="[
                      v => !!v || 'Folder description is required',
                      v =>
                        v.length <= 12 ||
                        'Description must be less than 12 characters'
                    ]"
                    hint="Any explalnation for this folder"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-5 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :rules="[v => !!v || 'Foldername is required']"
              :loading="creatingFolder"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" persistent max-width="600px">
      <v-card>
        <v-form
          ref="fileUploadForm"
          lazy-validation
          @submit.prevent="uploadFiles"
        >
          <v-card-title>
            <span class="text-h4 my-2"><strong>Upload File</strong></span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-text-field
                filled
                label="File Name"
                v-model="fileName"
                :rules="[v => !!v || 'Filename is required']"
              ></v-text-field>
              <v-file-input
                chips
                filled
                label="Choose File"
                :rules="[v => !!v || 'A file must be selected']"
                @change="initialiseUpload"
              ></v-file-input>
              <v-autocomplete
                filled
                label="Select Folder"
                :items="folders"
                item-text="name"
                chips
                item-value="id"
                v-model="selected"
                :rules="[v => !!v || 'Please selected a folder to continue']"
                no-data-text="No folders available, Please create a folder first"
              ></v-autocomplete>
            </v-container>
          </v-card-text>
          <v-card-actions class="pr-6 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="uploadDialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" type="submit" :loading="uploading">
              Upload
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          Delete this folder?
        </v-card-title>
        <v-card-text
          >You are about to delete <strong>{{ selectedName }}.</strong> This
          action cannot be reversed.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            Disagree
          </v-btn>
          <v-btn
            color="green darken-1"
            :loading="deletingFolder"
            text
            @click.native="deleteFolder"
          >
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Folders",
  data() {
    return {
      dialog: false,
      deleteDialog: false,
      uploadDialog: false,
      creatingFolder: false,
      deletingFolder: false,
      uploading: false,
      folderName: "",
      folderDescription: "",
      selectedID: "",
      selectedName: "",
      loading: true,
      fileName: "",
      user: {},
      folders: [],
      selected: null,
      uploadData: null
    };
  },
  methods: {
    openFolder(id) {
      this.$router.push(`/folders/${id}`);
    },
    async getFolders() {
      this.loading = true;
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users/me`;
        const userResponse = await axios.get(userUrl);
        const folderUrl = `${process.env.VUE_APP_BASE_URL}/folders?user.id=${userResponse.data?.id}`;
        const folderResponse = await axios.get(folderUrl);
        this.user = userResponse;
        console.log(folderResponse);
        this.folders = folderResponse.data;
      } catch (error) {
        console.log(error);
        this.$toast.error("Something went wrong getting folders");
      } finally {
        this.loading = false;
      }
    },
    async createFolder() {
      if (this.$refs.folderCreateForm.validate()) {
        this.creatingFolder = true;
        try {
          const folderUrl = `${process.env.VUE_APP_BASE_URL}/folders`;
          const folderResponse = await axios.post(folderUrl, {
            name: this.folderName,
            description: this.folderDescription,
            user: this.user.data.id
          });
          console.log(folderResponse);
          this.folderName = "";
          this.folderDescription = "";
          this.dialog = false;
          this.$toast.success("Folder created successfully");
          this.getFolders();
        } catch (error) {
          console.log(error);
          this.$toast.error(
            "Something went wrong, Could not create your folder"
          );
        } finally {
          this.creatingFolder = false;
        }
      }
    },
    async deleteFolder() {
      this.deletingFolder = true;
      try {
        const folderUrl = `${process.env.VUE_APP_BASE_URL}/folders/${this.selectedID}`;
        await axios.delete(folderUrl);
        this.deleteDialog = false;
        this.$toast.success("Folder Deleted successfully");
        this.getFolders();
      } catch (error) {
        console.log(error);
        this.$toast.error("Something went wrong, Could not delete your folder");
      } finally {
        this.deletingFolder = false;
      }
    },
    initiateDelete(id, name) {
      this.selectedID = id;
      this.selectedName = name;
      this.deleteDialog = true;
    },
    initialiseUpload(e) {
      const fileData = new FormData();
      fileData.append("files", e);
      this.uploadData = fileData;
    },
    async uploadFiles() {
      if (this.$refs.fileUploadForm.validate()) {
        this.uploading = true;
        try {
          const fileResponse = await axios.post(
            `${process.env.VUE_APP_BASE_URL}/upload`,
            this.uploadData
          );
          await axios.post(`${process.env.VUE_APP_BASE_URL}/files`, {
            name: this.fileName,
            from: this.user.data.id,
            folder: this.selected,
            media: fileResponse.data
          });
          // await axios.put(
          //   `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
          //   {
          //     files: [...fileResponse.data, ...this.userData.files]
          //   }
          // );
          this.$toast.success("Your file has been uploaded");
          this.$refs.fileUploadForm.reset();
          this.uploadDialog = false;
        } catch (e) {
          console.log(e);
          this.$toast.error("Something went wrong, could not upload file");
        } finally {
          this.uploading = false;
        }
      }
    }
  },
  mounted() {
    const AuthToken = localStorage.getItem("AuthToken");
    if (AuthToken) {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      this.getFolders();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>

<style></style>
